import store from "../stores/store";

const initialState = {
  criteria: {},
};

export default function searchCSWReducer(state = initialState, action) {
  switch (action.type) {
    case "loadconfiguration":
      {
        let newState = { ...state };

        newState["criteria"] = {};
        return newState;
      }
      break;

    case "csw/search/criteria/clear":
      {
        let newState = { ...state };

        newState["criteria"] = {};
        return newState;
      }
      break;

    case "csw/search/criteria/clone":
      {
        let newState = { ...state };

        newState["criteria"] = action.payload;
        return newState;
      }
      break;

    case "csw/search/criteria":
      {
        let newState = { ...state };

        if (!newState.criteria[action.payload.property]) {
          newState.criteria[action.payload.property] = "";
        }
        newState.criteria[action.payload.property] = action.payload.value;

        return { ...newState };
      }
      break;

    default:
      return state;
  }
}
